import {
  IonAvatar,
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
} from "@ionic/react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import axios from "axios";
import {
  calendar,
  calendarOutline,
  chevronForward,
  chevronForwardOutline,
  close,
  closeOutline,
  fileTrayFull,
  fileTrayFullOutline,
  people,
  peopleCircle,
  peopleCircleOutline,
  peopleOutline,
  print,
  printOutline,
} from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  AspectRatio,
  Box,
  Button,
  Card,
  Typography,
} from "@mui/joy";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import { Close, LibraryAdd, Person, Print } from "@mui/icons-material";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import useTituloPagina from "../../hooks/tituloPagina";

const MainPage = (props) => {
  const [cargando, setCargando] = useState(false);
  const [paciente, setPaciente] = useState({});

  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);

  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [prestadoresRecientes, setPrestadoresRecientes] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const traerTurnosPaciente = async (paciente) => {
    let turnosFuturos = null;
    let tmpPrestadoresRecientes = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config
        );
        if (response.data.length !== 0) {
          turnosFuturos = response.data;
          tmpPrestadoresRecientes = response.data;

          //*Logica para los turnos futuros
          turnosFuturos = turnosFuturos.filter((turno) => {
            return dayjs(new dayjs()).isBefore(dayjs(turno.fecha));
          });
          turnosFuturos = turnosFuturos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnosFuturos = turnosFuturos.slice(0, 5);

          //*Logica para prestadores recientes
          tmpPrestadoresRecientes = tmpPrestadoresRecientes
            .sort((a, b) => dayjs(b.fecha).diff(dayjs(a.fecha))) // Orden cronológico inverso
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.prestadorCod === value.prestadorCod &&
                    t.prestadorNom === value.prestadorNom
                )
            )
            .slice(0, 4) // Seleccionar los 4 más recientes
            .map((turno) => {
              return {
                prestadorCod: turno.prestadorCod,
                prestadorNom: turno.prestadorNom,
                especialidadNom: turno.especialidadNom,
              };
            })
            .sort((a, b) => a.prestadorNom.localeCompare(b.prestadorNom));
        } else {
          turnosFuturos = [];
          tmpPrestadoresRecientes = [];
        }
        setListadoTurnos(turnosFuturos);
        setPrestadoresRecientes(tmpPrestadoresRecientes);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo"
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo"
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };
  const CancelarTurno = async () => {
    try {
      const urlAxioPP = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      let servicio = null;
      const serviciosResponse = await axios.get(
        `${urlAxioPP}Servicios`,
        config
      );

      if (serviciosResponse.data.length !== 0) {
        servicio = serviciosResponse.data[0];
      }

      if (servicio?.codigo !== null && turnoSeleccionado) {
        const cancelarTurnoResponse = await axios
          .patch(
            `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
            "",
            config
          )
          .then(
            async () =>
              await axios.patch(
                `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
                "",
                config
              )
          );

        if (
          cancelarTurnoResponse.status === 200 &&
          cancelarTurnoResponse.statusText === "OK"
        ) {
          mostrarNotificacion(
            true,
            "El turno se cancelo correctamente",
            "verde"
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo"
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion);

        traerEstudios(sesion);
        TraerServicio(sesion);
        setPaciente(sesion);
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const handleClickRedirigir = (destino) => {
    switch (destino) {
      case "Reservar turno":
        history.push({ pathname: "/portal/Reservar turno" });
        break;
      case "Horarios":
        history.push({ pathname: "/portal/Horarios" });
        break;
      case "Turnos":
        history.push({ pathname: "/portal/Turnos" });
        break;
      case "Estudios":
        history.push({ pathname: "/portal/Estudios" });
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargando(true);
    await CancelarTurno();
    await traerTurnosPaciente(paciente);
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "+5493512297252";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      ""
    );
  };

  const handleClickComprobanteTurno = (turno) => {
    const prestadorEncontrado = prestadores.find(
      (prestador) => turno.prestadorCod === prestador.codigo
    );
    const servicioEncontrado = servicios.find(
      (servicio) => servicio.codigo === turno.servicio
    );
    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: paciente.apellido,
      nombre: paciente.nombre,
      mutualNombre: paciente.mutualNombre,
      mutualAfiliado: paciente.mutualAfiliado,
      hc: paciente.hc,
      documentoTipoNombre: paciente.documentoTipoNombre,
      documentoNro: paciente.documentoNro,
      celular: paciente.celular,
      email: paciente.email,
      lugarAtencion:
        (prestadorEncontrado ? prestadorEncontrado.domicilioTurno : null) ||
        (servicioEncontrado ? servicioEncontrado.direccion : "") ||
        "",
      preparacionEstudio:
        /*estudios.find((estudio) => estudio.codigo === turno.estudio)[0]?.preparacion !== ""
          ? convertToPlain(
              estudios.filter((estudio) => estudio.codigo === turno.estudio)[0]?.preparacion
            )
          :*/ null,
    });
    setAbrirComprobanteTurno(true);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickReservarTurnoPrestador = (prestador) => {
    history.push({
      pathname: "/portal/Reservar turno",
      state: { prestador: prestador },
    });
  };

  const renderPrestadoresRecientes = (seePreviusVersion) => {
    return (
      <Row
        style={{ textAlign: "start" }}
        alignItems="stretch"
        container
        spacing={2}
        // paddingInline={1}
      >
        {prestadoresRecientes.map((fila) => (
          <Column xs={12} md={6} xl={4}>
            <Card
              key={fila.prestadorCod}
              style={{ marginBottom: "7.5px", padding: "0px 14px" }}
              variant="outlined"
            >
              <Row
                className="amarillo-sol"
                style={{ textAlign: "start" }}
                alignItems="center"
                container
              >
                <Column xs={12} sx={{ padding: "0px" }}>
                  <CustomInput
                    fullWidth
                    margin="normal"
                    startDecorator={
                      <React.Fragment>
                        <Button
                          type="button"
                          variant="plain"
                          color="neutral"
                          disabled
                          sx={{ textAlign: "start", paddingLeft: "0px" }}
                        >
                          <Person sx={{ color: "#1a336e" }} />
                          <Typography sx={{ color: "#1a336e" }}>
                            <Typography
                              sx={{ color: "#1a336e" }}
                              level="body-sm"
                            >{` ${fila.prestadorNom} - ${fila.especialidadNom}`}</Typography>
                          </Typography>
                        </Button>
                      </React.Fragment>
                    }
                    endDecorator={
                      <React.Fragment>
                        <Button
                          type="button"
                          variant="plain"
                          color="neutral"
                          sx={{ color: "#1a336e", paddingRight: "4px" }}
                          onClick={() =>
                            handleClickReservarTurnoPrestador(fila.prestadorCod)
                          }
                        >
                          <Typography
                            level="title-sm"
                            sx={{ color: "#1a336e" }}
                          >
                            {`Reservar turno`.toUpperCase()}
                          </Typography>
                          <LibraryAdd />
                        </Button>
                      </React.Fragment>
                    }
                    type="button"
                    variant="plain"
                    value=" "
                    inputDisabled
                    sx={{ paddingLeft: "0px", fontWeight: "5px" }}
                  />
                </Column>
              </Row>
            </Card>
          </Column>
        ))}
      </Row>
    );
  };

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <IonIcon slot="start" md={calendar} ios={calendarOutline} />
        <Column className="" xs={12} marginBottom={1}>
          <Row>
            <Typography level="body-sm">Proximos turnos</Typography>
          </Row>
        </Column>
        {listadoTurnos.map((fila) => (
          <Card
            style={{ marginBottom: "7.5px", padding: "0px 14px" }}
            key={fila.codigo}
          >
            <Row
              className=""
              style={{ textAlign: "start" }}
              alignItems="center"
              container
            >
              <Column
                style={{ textAlign: "start" }}
                xs={6}
                md={8}
                lg={10}
                container
              >
                <Row alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm" sx={{ color: "#1a336e" }}>
                      {fila.prestadorNom === "EQUIPOS"
                        ? `${fila.estudioNom}`
                        : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                    </Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm">
                      {`${obtenerNombreDia(
                        dayjs(fila.fecha).format("dddd")
                      )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                        fila.fecha
                      ).format("MMMM, YYYY")} a las ${dayjs(fila.hora).format(
                        "HH:mm"
                      )}`}
                    </Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`Estado: ${
                      fila.asistio
                        ? "Asistido"
                        : fila.aCancelar
                        ? "Pendiente"
                        : "Cancelado"
                    }`}</Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12}>
                    <Typography level="body-sm">
                      {fila.prestadorNom === "EQUIPOS" &&
                      estudios.filter(
                        (estudio) => estudio.codigo === fila.estudio
                      )[0]?.preparacion !== ""
                        ? convertToPlain(
                            estudios.filter(
                              (estudio) => estudio.codigo === fila.estudio
                            )[0]?.preparacion
                          )
                        : null}
                    </Typography>
                  </Column>
                </Row>
              </Column>
              <Column container xs={6} md={4} lg={2}>
                <Row container>
                  {(dayjs().format("YYYY-MM-DD") !==
                    dayjs(fila.fecha).format("YYYY-MM-DD") ||
                    (dayjs().format("YYYY-MM-DD") ===
                      dayjs(fila.fecha).format("YYYY-MM-DD") &&
                      dayjs(fila.hora).format("HH:mm") >
                        dayjs().format("HH:mm"))) &&
                  fila.aCancelar ? (
                    <Column xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#1a336e" }}
                        />
                        <IonLabel style={{ color: "#1a336e" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickSeleccionarTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={closeOutline}
                          md={close}
                          style={{ color: "#1a336e" }}
                        />
                        <IonLabel style={{ color: "#1a336e" }}>
                          Cancelar
                        </IonLabel>
                      </IonButton>
                    </Column>
                  ) : (
                    <Column className="" xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#1a336e" }}
                        />
                        <IonLabel style={{ color: "#1a336e" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>

                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() =>
                          handleClickReservarTurnoPrestador(fila.prestadorCod)
                        }
                        style={{ margin: "0px" }}
                      >
                        <Typography level="title-sm" sx={{ color: "#1a336e" }}>
                          {`Reservar turno`.toUpperCase()}
                        </Typography>
                        <LibraryAdd sx={{ color: "#1a336e" }} />
                      </IonButton>
                    </Column>
                  )}
                </Row>
              </Column>
            </Row>
          </Card>
        ))}
      </IonGrid>
    );
  };

  return (
    <IonGrid>
      <IonRow>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            lines="none"
            onClick={() => handleClickRedirigir("Reservar turno")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={peopleCircleOutline}
                md={peopleCircle}
                size="large"
              />
            </IonAvatar>
            <Typography level="body-md">Reservar un nuevo turno</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            lines="none"
            onClick={() => handleClickRedirigir("Horarios")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon ios={peopleOutline} md={people} size="large" />
            </IonAvatar>
            <Typography level="body-md">
              Horarios de nuestros prestadores
            </Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            lines="none"
            onClick={() => handleClickRedirigir("Turnos")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon ios={calendarOutline} md={calendar} size="large" />
            </IonAvatar>
            <Typography level="body-md">Consultar mis turnos</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            lines="none"
            onClick={() => handleClickRedirigir("Estudios")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={fileTrayFullOutline}
                md={fileTrayFull}
                size="large"
              />
            </IonAvatar>
            <Typography level="body-md">Consultar mis estudios</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
      </IonRow>

      {listadoTurnos.length !== 0 && renderTurnosLista(true)}
      {prestadoresRecientes.length !== 0 && (
        <AccordionGroup>
          <Accordion>
            <AccordionSummary>Prestadores recientes</AccordionSummary>
            <AccordionDetails>{renderPrestadoresRecientes()}</AccordionDetails>
          </Accordion>
        </AccordionGroup>
      )}

      <DialogoConfirmacion
        titulo="Cancelar turno"
        texto={`Ha decidido cancelar el turno con el/la profecional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el dia ${obtenerNombreDia(
          dayjs(turnoSeleccionado.fecha).format("dddd")
        )} ${dayjs(turnoSeleccionado.fecha).format("DD")} de ${dayjs(
          turnoSeleccionado.fecha
        ).format("MMMM, YYYY")} a las ${dayjs(turnoSeleccionado.hora).format(
          "HH:mm"
        )}, ¿Esta seguro/a de ello?`}
        open={abrirModalCancelarReserva}
        setOpen={setAbrirModalCancelarReserva}
        handleClickConfirmar={handleClickCancelarReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No"
        textoBotonSi="Si, cancelo"
      />

      <ComprobanteTurno
        turno={turnoSeleccionado}
        abrir={abrirComprobanteTurno}
        togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
        paciente={paciente}
      />
    </IonGrid>
  );
};

export default MainPage;
